module.exports = __webpack_public_path__ + "img/2.06.thmb.xs.a4fe5ba9.jpg";